import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEN from './assets/locale/en/translation.json';
import translationSV from './assets/locale/sv/translation.json';
import translationFI from './assets/locale/fi/translation.json';
import translationDK from './assets/locale/dk/translation.json';
import translationNO from './assets/locale/no/translation.json';

const resources = {
	en: {
		translation: translationEN,
	},
	sv: {
		translation: translationSV,
	},
	fi: {
		translation: translationFI,
	},
	da: {
		translation: translationDK,
	},
	dk: {
		translation: translationDK,
	},
	nb: {
		translation: translationNO,
	},
	no: {
		translation: translationNO,
	},
};

i18n.use(detector)
	.use(initReactI18next)
	.init({
		resources,
		lng: 'en',
		fallbackLng: 'en',
		keySeparator: false,
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
